export const APP_VERSION = '20261103-837c47f';